export default __webpack_public_path__ + "static/media/tapicerowane6.121dfe9b.jpg";